import CategorizedListSection from './CategorizedListSection';

export default CategorizedListSection;
